import { useNavigationContext } from '../../../contexts/NavigationContext';
import MainLayout from '../../../components/Display/MainLayout';
import MemberPage from './member/MemberPage';
import NewsPage from '../news/NewsPage';
import { CONSTANT } from '../../../utils/constants';
import JobOfferPage from './joboffer/JobOfferPage';
import './Rab.scss';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (
    <MainLayout enableAnalytics={false} scope={'rab'} websiteLabel={'rab.fr'}>
      <NewsPage
        isActive={navigationContext.activeAppKey === 'news'}
        scope={'rab'}
        tagsType={'def_keywords'}
        typeList={CONSTANT.rab.availableNewsTypes}
        ratio={1.78}
        imageIsRequired={true}
      />
      <MemberPage isActive={navigationContext.activeAppKey === 'member'} />
      <JobOfferPage isActive={navigationContext.activeAppKey === 'joboffer'} />
    </MainLayout>
  );
}

export default Home;
